import { render, staticRenderFns } from "./ClicMongoDBChart.vue?vue&type=template&id=d36af34a&"
import script from "./ClicMongoDBChart.vue?vue&type=script&lang=js&"
export * from "./ClicMongoDBChart.vue?vue&type=script&lang=js&"
import style0 from "./ClicMongoDBChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports